import type { Project } from "../../types/project";

export const audioStreaming: Project = {
  id: "real-time-audio-streaming",
  title: "Real-Time Audio Streaming Application",
  description:
    "A full-stack music streaming platform with real-time chat, live listening activity, album management, analytics, and secure authentication.",
  techStack: [
    "React",
    "TypeScript",
    "Node.js",
    "MongoDB",
    "Socket.IO",
    "Clerk",
    "Cloudinary",
  ],
  githubUrl:
    "https://github.com/thvvamshi/Real-time_audio_streaming_application",
  liveUrl: "https://real-time-audio-streaming-application.onrender.com",
  image:
    "https://opengraph.githubassets.com/07299b8e913ec09cb7b33f038b688537036bb9ba88db9ff497c23ce649ed5a30/thvvamshi/Real-time_audio_streaming_application",
  featured: true,
  category: "Real-Time Systems",
  highlights: [
    "Live listening activity and realtime chat",
    "Secure authentication and media management",
    "Analytics and album administration workflows",
  ],
};
